module.exports = __webpack_public_path__ + "img/beer_id-49.df5d0c7f.png";